// // // src/components/ServiceSelectorModal.jsx
// // import { useState } from "react";
// // import { getActivePayableServices, getPlanById } from "../utils/paymentConfig";

// // export default function ServiceSelectorModal({ onSelect, onClose }) {
// //   const [selected, setSelected] = useState(null);
// //   const activeServices = getActivePayableServices();

// //   const selectedService = activeServices.find(s => s.serviceCode === selected);
// //   const selectedPlan = selectedService?.planId ? getPlanById(selectedService.planId) : null;

// //   function handleConfirm() {
// //     if (!selected) return;
// //     onSelect(selected);
// //   }

// //   return (
// //     <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
// //       <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 540, padding: "32px 28px", position: "relative", boxShadow: "0 20px 60px rgba(0,0,0,0.15)", maxHeight: "90vh", overflowY: "auto" }}>

// //         {/* Close */}
// //         <button
// //           onClick={onClose}
// //           style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 20, color: "#94a3b8", cursor: "pointer", lineHeight: 1 }}
// //         >
// //           ✕
// //         </button>

// //         {/* Header */}
// //         <div style={{ marginBottom: 24 }}>
// //           <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.02em", color: "#1e293b" }}>
// //             Select a Service
// //           </h2>
// //           <p style={{ fontSize: 14, color: "#64748b" }}>
// //             Choose the service you want to purchase. Each service is billed separately.
// //           </p>
// //         </div>

// //         {/* No active services */}
// //         {activeServices.length === 0 && (
// //           <div style={{ textAlign: "center", padding: "40px 20px", color: "#64748b", fontSize: 14 }}>
// //             <div style={{ fontSize: 40, marginBottom: 12 }}>🔧</div>
// //             No active services available right now. Please check back soon!
// //           </div>
// //         )}

// //         {/* Service list */}
// //         <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 24 }}>
// //           {activeServices.map(service => {
// //             const plan = service.planId ? getPlanById(service.planId) : null;
// //             const isSelected = selected === service.serviceCode;

// //             return (
// //               <div
// //                 key={service.serviceCode}
// //                 onClick={() => setSelected(service.serviceCode)}
// //                 style={{
// //                   border:      isSelected ? "2px solid #2563eb" : "1.5px solid #e2e8f0",
// //                   borderRadius: 12,
// //                   padding:     "16px 18px",
// //                   cursor:      "pointer",
// //                   background:  isSelected ? "#eff6ff" : "#fff",
// //                   transition:  "all 0.15s",
// //                   display:     "flex",
// //                   alignItems:  "center",
// //                   gap:         14,
// //                 }}
// //                 onMouseEnter={e => { if (!isSelected) { e.currentTarget.style.borderColor = "#93c5fd"; e.currentTarget.style.background = "#f8fafc"; } }}
// //                 onMouseLeave={e => { if (!isSelected) { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.background = "#fff"; } }}
// //               >
// //                 {/* Radio */}
// //                 <div style={{
// //                   width:      20,
// //                   height:     20,
// //                   borderRadius: "50%",
// //                   border:     isSelected ? "6px solid #2563eb" : "2px solid #cbd5e1",
// //                   flexShrink: 0,
// //                   transition: "all 0.15s",
// //                 }} />

// //                 {/* Icon */}
// //                 <span style={{ fontSize: 28, flexShrink: 0 }}>{service.icon}</span>

// //                 {/* Info */}
// //                 <div style={{ flex: 1 }}>
// //                   <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
// //                     <span style={{ fontWeight: 700, fontSize: 15, color: "#1e293b" }}>
// //                       {service.title}
// //                     </span>
// //                     {service.badge && (
// //                       <span style={{ background: service.badgeBg || "#EAF3DE", color: service.badgeColor || "#3B6D11", fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20 }}>
// //                         {service.badge}
// //                       </span>
// //                     )}
// //                   </div>
// //                   <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.5, marginBottom: 8 }}>
// //                     {service.description}
// //                   </div>
// //                   {/* Highlights */}
// //                   <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
// //                     {service.highlights.map(h => (
// //                       <span key={h} style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: isSelected ? "#dbeafe" : "#f1f5f9", color: isSelected ? "#1d4ed8" : "#475569", fontWeight: 500 }}>
// //                         {h}
// //                       </span>
// //                     ))}
// //                   </div>
// //                 </div>

// //                 {/* Price */}
// //                 <div style={{ textAlign: "right", flexShrink: 0, minWidth: 70 }}>
// //                   <div style={{ fontWeight: 800, fontSize: 22, color: isSelected ? "#2563eb" : "#1e293b", lineHeight: 1 }}>
// //                     {plan?.price || "Free"}
// //                   </div>
// //                   <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 3 }}>
// //                     {plan?.period || ""}
// //                   </div>
// //                 </div>
// //               </div>
// //             );
// //           })}
// //         </div>

// //         {/* Selected summary */}
// //         {selected && selectedPlan && (
// //           <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "14px 16px", marginBottom: 20 }}>
// //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
// //               <div>
// //                 <div style={{ fontSize: 13, fontWeight: 600, color: "#1e40af" }}>
// //                   {selectedService?.icon} {selectedService?.title}
// //                 </div>
// //                 <div style={{ fontSize: 12, color: "#3b82f6", marginTop: 2 }}>
// //                   {selectedPlan.name} · {selectedPlan.period}
// //                 </div>
// //               </div>
// //               <div style={{ fontWeight: 800, fontSize: 20, color: "#2563eb" }}>
// //                 {selectedPlan.price}
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         {/* Actions */}
// //         <div style={{ display: "flex", gap: 10 }}>
// //           <button
// //             onClick={onClose}
// //             style={{ flex: 1, padding: "12px", background: "#fff", color: "#475569", border: "1.5px solid #e2e8f0", borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: "pointer" }}
// //             onMouseEnter={e => e.currentTarget.style.borderColor = "#94a3b8"}
// //             onMouseLeave={e => e.currentTarget.style.borderColor = "#e2e8f0"}
// //           >
// //             Cancel
// //           </button>
// //           <button
// //             onClick={handleConfirm}
// //             disabled={!selected}
// //             style={{ flex: 2, padding: "12px", background: selected ? "linear-gradient(135deg, #2563eb, #1d4ed8)" : "#e2e8f0", color: selected ? "#fff" : "#94a3b8", border: "none", borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: selected ? "pointer" : "not-allowed", transition: "all 0.15s", boxShadow: selected ? "0 4px 12px rgba(37,99,235,0.25)" : "none" }}
// //             onMouseEnter={e => { if (selected) e.currentTarget.style.transform = "translateY(-1px)"; }}
// //             onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; }}
// //           >
// //             {selected ? `Continue to Payment → ${selectedPlan?.price || ""}` : "Select a service to continue"}
// //           </button>
// //         </div>

// //       </div>
// //     </div>
// //   );
// // }

// // new code  - price changes
// import { useState } from "react";
// import servicesConfig from "../utils/servicesConfig";
// import { usePricing } from "../hooks/usePricing";

// export default function ServiceSelectorModal({ onSelect, onClose }) {
//   const [selected, setSelected] = useState(null);

//   // Live localised pricing for each plan
//   const { usdDisplay: atsPrice, localDisplay: atsLocal } = usePricing("ats_basic");
//   const { usdDisplay: docPrice, localDisplay: docLocal } = usePricing("doc_pro");

//   function getPriceDisplay(planId) {
//     if (planId === "doc_pro") return { price: docPrice, local: docLocal };
//     return { price: atsPrice, local: atsLocal };
//   }

//   // Only show enabled, active plans
//   const plans = servicesConfig.plans.filter(p => p.enabled && p.active);

//   function handleContinue() {
//     if (!selected) return;
//     onSelect(selected);
//   }

//   return (
//     <div
//       onClick={e => { if (e.target === e.currentTarget) onClose(); }}
//       style={{
//         position: "fixed", inset: 0, zIndex: 2000,
//         background: "rgba(15,23,42,0.65)", backdropFilter: "blur(6px)",
//         display: "flex", alignItems: "center", justifyContent: "center",
//         padding: 16,
//       }}
//     >
//       <div style={{
//         background: "#fff", borderRadius: 18, width: "100%", maxWidth: 520,
//         boxShadow: "0 24px 64px rgba(0,0,0,0.25)",
//         animation: "modalIn 0.2s ease", overflow: "hidden",
//       }}>

//         {/* Header */}
//         <div style={{ padding: "20px 24px 16px", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//           <div>
//             <h2 style={{ fontSize: 17, fontWeight: 700, color: "#0f172a", margin: 0 }}>Select a Plan</h2>
//             <p style={{ fontSize: 13, color: "#64748b", margin: "4px 0 0" }}>One-time payment — no subscription.</p>
//           </div>
//           <button onClick={onClose}
//             style={{ background: "none", border: "1px solid #e2e8f0", borderRadius: 8, width: 32, height: 32, cursor: "pointer", fontSize: 17, color: "#64748b", display: "flex", alignItems: "center", justifyContent: "center" }}>
//             ×
//           </button>
//         </div>

//         {/* Plan list */}
//         <div style={{ padding: "16px 24px", display: "flex", flexDirection: "column", gap: 12, maxHeight: "60vh", overflowY: "auto" }}>
//           {plans.map(plan => {
//             const { price, local } = getPriceDisplay(plan.id);
//             const isSelected = selected === plan.id;
//             // Only show PRIMARY paid services as rows — free bonuses shown as feature pills below
//             const PRIMARY_SERVICES = ["ATS_ANALYSIS", "ATS_RESUME_IMPROVED", "DOCUMENT_SUMMARY", "DOCUMENT_CHAT"];
//             const services = servicesConfig.services.filter(
//               s => plan.includes?.includes(s.serviceCode) && s.active && PRIMARY_SERVICES.includes(s.serviceCode)
//             );

//             // Free bonuses shown separately as a single "what's included free" row
//             const freeBonuses = servicesConfig.services.filter(
//               s => plan.includes?.includes(s.serviceCode) && s.active && s.isFree && !PRIMARY_SERVICES.includes(s.serviceCode)
//             );

//             return (
//               <div
//                 key={plan.id}
//                 onClick={() => setSelected(plan.id)}
//                 style={{
//                   border:       `2px solid ${isSelected ? "#2563eb" : "#e2e8f0"}`,
//                   borderRadius: 14,
//                   padding:      "16px",
//                   cursor:       "pointer",
//                   background:   isSelected ? "#eff6ff" : "#fff",
//                   transition:   "all 0.15s",
//                   position:     "relative",
//                 }}
//                 onMouseEnter={e => { if (!isSelected) e.currentTarget.style.borderColor = "#93c5fd"; }}
//                 onMouseLeave={e => { if (!isSelected) e.currentTarget.style.borderColor = "#e2e8f0"; }}
//               >
//                 {/* Selection indicator */}
//                 <div style={{ position: "absolute", top: 14, right: 14 }}>
//                   <div style={{
//                     width: 20, height: 20, borderRadius: "50%",
//                     border: `2px solid ${isSelected ? "#2563eb" : "#cbd5e1"}`,
//                     background: isSelected ? "#2563eb" : "#fff",
//                     display: "flex", alignItems: "center", justifyContent: "center",
//                   }}>
//                     {isSelected && (
//                       <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
//                         <polyline points="20 6 9 17 4 12"/>
//                       </svg>
//                     )}
//                   </div>
//                 </div>

//                 {/* Plan header */}
//                 <div style={{ display: "flex", alignItems: "flex-start", gap: 12, marginBottom: 12, paddingRight: 28 }}>
//                   <div style={{ flex: 1 }}>
//                     <div style={{ fontWeight: 700, fontSize: 15, color: "#0f172a", marginBottom: 2 }}>{plan.name}</div>
//                     <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.5 }}>{plan.description}</div>
//                   </div>

//                   {/* Price — USD + local */}
//                   <div style={{ textAlign: "right", flexShrink: 0 }}>
//                     <div style={{ fontSize: 22, fontWeight: 800, color: isSelected ? "#2563eb" : "#0f172a", lineHeight: 1 }}>
//                       {price}
//                     </div>
//                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>one-time</div>
//                     {local && (
//                       <div style={{
//                         fontSize: 11, color: isSelected ? "#3b82f6" : "#64748b",
//                         background: isSelected ? "#dbeafe" : "#f1f5f9",
//                         padding: "1px 7px", borderRadius: 20, marginTop: 4,
//                         display: "inline-block",
//                       }}>
//                         ≈{local}
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Primary paid services */}
//                 <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                   {services.map(svc => (
//                     <div key={svc.serviceCode} style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                       <div style={{ width: 28, height: 28, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>
//                         {svc.icon}
//                       </div>
//                       <div style={{ flex: 1, minWidth: 0 }}>
//                         <div style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{svc.title}</div>
//                         <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 1 }}>{svc.description}</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Free bonuses — shown as a compact single row */}
//                 {freeBonuses.length > 0 && (
//                   <div style={{ marginTop: 8, padding: "8px 12px", background: isSelected ? "#f0fdf4" : "#f8fafc", borderRadius: 9, border: `1px solid ${isSelected ? "#bbf7d0" : "#e2e8f0"}`, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
//                     <span style={{ fontSize: 11, fontWeight: 700, color: "#059669", background: "#dcfce7", padding: "1px 8px", borderRadius: 20, flexShrink: 0 }}>FREE</span>
//                     <span style={{ fontSize: 12, color: "#374151" }}>
//                       Also includes:{" "}
//                       {freeBonuses.map((b, i) => (
//                         <span key={b.serviceCode}>
//                           {b.title}{i < freeBonuses.length - 1 ? " · " : ""}
//                         </span>
//                       ))}
//                     </span>
//                   </div>
//                 )}

//                 {/* Feature highlights */}
//                 <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginTop: 10 }}>
//                   {plan.features.filter(f => f.included).slice(0, 5).map(f => (
//                     <span key={f.text} style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: isSelected ? "#dbeafe" : "#f1f5f9", color: isSelected ? "#1d4ed8" : "#475569", fontWeight: 500 }}>
//                       {f.text}
//                     </span>
//                   ))}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* Footer */}
//         <div style={{ padding: "16px 24px 20px", borderTop: "1px solid #f1f5f9", display: "flex", gap: 10 }}>
//           <button onClick={onClose}
//             style={{ flex: 1, padding: "11px", background: "#fff", color: "#64748b", border: "1.5px solid #e2e8f0", borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
//             Cancel
//           </button>
//           <button
//             onClick={handleContinue}
//             disabled={!selected}
//             style={{
//               flex: 2, padding: "11px",
//               background: selected ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#e2e8f0",
//               color: selected ? "#fff" : "#94a3b8",
//               border: "none", borderRadius: 10, fontWeight: 700, fontSize: 14,
//               cursor: selected ? "pointer" : "not-allowed",
//               transition: "all 0.2s",
//             }}
//           >
//             {selected
//               ? `Continue with ${plans.find(p => p.id === selected)?.name} →`
//               : "Select a plan to continue"}
//           </button>
//         </div>
//       </div>

//       <style>{`
//         @keyframes modalIn {
//           from { opacity:0; transform:scale(0.96) translateY(8px); }
//           to   { opacity:1; transform:scale(1) translateY(0); }
//         }
//       `}</style>
//     </div>
//   );
// }

import { useState } from "react";
import servicesConfig from "../utils/servicesConfig";
import { usePricing } from "../hooks/usePricing";

export default function ServiceSelectorModal({ onSelect, onClose }) {
  const [selected, setSelected] = useState(null);

  const { usdDisplay: atsPrice, localDisplay: atsLocal } = usePricing("ats_basic");
  const { usdDisplay: docPrice, localDisplay: docLocal } = usePricing("doc_pro");

  function getPriceDisplay(planId) {
    if (planId === "doc_pro") return { price: docPrice, local: docLocal };
    return { price: atsPrice, local: atsLocal };
  }

  const plans = servicesConfig.plans.filter(p => p.enabled && p.active);

  function handleContinue() {
    if (!selected) return;
    onSelect(selected);
  }

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: "fixed", inset: 0, zIndex: 2000,
        background: "rgba(15,23,42,0.65)", backdropFilter: "blur(6px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 16,
      }}
    >
      <div style={{
        background: "#fff", borderRadius: 18, width: "100%", maxWidth: 520,
        boxShadow: "0 24px 64px rgba(0,0,0,0.25)",
        animation: "modalIn 0.2s ease", overflow: "hidden",
      }}>

        {/* ── Header ── */}
        <div style={{ padding: "20px 24px 16px", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <h2 style={{ fontSize: 17, fontWeight: 700, color: "#0f172a", margin: 0 }}>Select a Plan</h2>
            <p style={{ fontSize: 13, color: "#64748b", margin: "4px 0 0" }}>One-time payment — no subscription.</p>
          </div>
          <button onClick={onClose}
            style={{ background: "none", border: "1px solid #e2e8f0", borderRadius: 8, width: 32, height: 32, cursor: "pointer", fontSize: 17, color: "#64748b", display: "flex", alignItems: "center", justifyContent: "center" }}>
            ×
          </button>
        </div>

        {/* ── Plan list ── */}
        <div style={{ padding: "16px 24px", display: "flex", flexDirection: "column", gap: 12, maxHeight: "62vh", overflowY: "auto" }}>
          {plans.map(plan => {
            const { price, local } = getPriceDisplay(plan.id);
            const isSelected = selected === plan.id;

            // Split features from servicesConfig — paid vs free
            // "Free" features are those whose text contains "free" or "Free"
            const allFeatures  = (plan.features || []).filter(f => f.included);
            const paidFeatures = allFeatures.filter(f => !/free/i.test(f.text));
            const freeFeatures = allFeatures.filter(f => /free/i.test(f.text));

            return (
              <div
                key={plan.id}
                onClick={() => setSelected(plan.id)}
                style={{
                  border:       `2px solid ${isSelected ? "#2563eb" : "#e2e8f0"}`,
                  borderRadius: 14,
                  padding:      "16px",
                  cursor:       "pointer",
                  background:   isSelected ? "#eff6ff" : "#fff",
                  transition:   "all 0.15s",
                  position:     "relative",
                }}
                onMouseEnter={e => { if (!isSelected) e.currentTarget.style.borderColor = "#93c5fd"; }}
                onMouseLeave={e => { if (!isSelected) e.currentTarget.style.borderColor = "#e2e8f0"; }}
              >
                {/* Radio indicator */}
                <div style={{ position: "absolute", top: 14, right: 14 }}>
                  <div style={{
                    width: 20, height: 20, borderRadius: "50%",
                    border: `2px solid ${isSelected ? "#2563eb" : "#cbd5e1"}`,
                    background: isSelected ? "#2563eb" : "#fff",
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    {isSelected && (
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                    )}
                  </div>
                </div>

                {/* Plan name + price */}
                <div style={{ display: "flex", alignItems: "flex-start", gap: 12, marginBottom: 14, paddingRight: 28 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: "#0f172a", marginBottom: 3 }}>{plan.name}</div>
                    <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.5 }}>{plan.description}</div>
                  </div>
                  <div style={{ textAlign: "right", flexShrink: 0 }}>
                    <div style={{ fontSize: 22, fontWeight: 800, color: isSelected ? "#2563eb" : "#0f172a", lineHeight: 1 }}>
                      {price}
                    </div>
                    <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>one-time</div>
                    {local && (
                      <div style={{
                        fontSize: 11,
                        color:      isSelected ? "#1d4ed8" : "#64748b",
                        background: isSelected ? "#dbeafe" : "#f1f5f9",
                        padding: "2px 8px", borderRadius: 20, marginTop: 4,
                        display: "inline-block",
                      }}>
                        ≈{local}
                      </div>
                    )}
                  </div>
                </div>

                {/* ── Paid features ── */}
                <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: freeFeatures.length > 0 ? 10 : 0 }}>
                  {paidFeatures.map(f => (
                    <div key={f.text} style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                      <div style={{
                        width: 18, height: 18, borderRadius: "50%", flexShrink: 0, marginTop: 1,
                        background: isSelected ? "#dbeafe" : "#f0f9ff",
                        border: `1px solid ${isSelected ? "#93c5fd" : "#e0f2fe"}`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}>
                        <svg width="9" height="9" viewBox="0 0 24 24" fill="none"
                          stroke={isSelected ? "#2563eb" : "#0369a1"} strokeWidth="3">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </div>
                      <span style={{ fontSize: 12, color: "#374151", lineHeight: 1.5 }}>{f.text}</span>
                    </div>
                  ))}
                </div>

                {/* ── Free bonus features — green row ── */}
                {freeFeatures.length > 0 && (
                  <div style={{
                    padding: "10px 12px",
                    background: isSelected ? "#f0fdf4" : "#f8fffe",
                    border: `1px solid ${isSelected ? "#86efac" : "#d1fae5"}`,
                    borderRadius: 10,
                  }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "#059669", marginBottom: 6, display: "flex", alignItems: "center", gap: 5 }}>
                      🎁 Also included — free:
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                      {freeFeatures.map(f => (
                        <div key={f.text} style={{ display: "flex", alignItems: "flex-start", gap: 7 }}>
                          <div style={{
                            width: 16, height: 16, borderRadius: "50%", flexShrink: 0, marginTop: 1,
                            background: "#dcfce7", border: "1px solid #86efac",
                            display: "flex", alignItems: "center", justifyContent: "center",
                          }}>
                            <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="3">
                              <polyline points="20 6 9 17 4 12"/>
                            </svg>
                          </div>
                          {/* Strip "- Free" or "- free" from the label since it's in the green section already */}
                          <span style={{ fontSize: 12, color: "#166534", lineHeight: 1.5 }}>
                            {f.text.replace(/\s*[-–]\s*free/gi, "").trim()}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* ── Footer ── */}
        <div style={{ padding: "14px 24px 20px", borderTop: "1px solid #f1f5f9", display: "flex", gap: 10 }}>
          <button onClick={onClose}
            style={{ flex: 1, padding: "11px", background: "#fff", color: "#64748b", border: "1.5px solid #e2e8f0", borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
            Cancel
          </button>
          <button
            onClick={handleContinue}
            disabled={!selected}
            style={{
              flex: 2, padding: "11px",
              background: selected ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#e2e8f0",
              color: selected ? "#fff" : "#94a3b8",
              border: "none", borderRadius: 10, fontWeight: 700, fontSize: 14,
              cursor: selected ? "pointer" : "not-allowed",
              transition: "all 0.2s",
            }}
          >
            {selected
              ? `Continue with ${plans.find(p => p.id === selected)?.name} →`
              : "Select a plan to continue"}
          </button>
        </div>

      </div>

      <style>{`
        @keyframes modalIn {
          from { opacity:0; transform:scale(0.96) translateY(8px); }
          to   { opacity:1; transform:scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
}
